<template>
  <div id="app">
    <Head></Head>
    <Nav></Nav>
    <router-view></router-view>
    <Foot></Foot>
  </div>
</template>

<script>
import Head from './components/Head';
import Nav from './components/Nav';
import Foot from './components/Footer'
export default {
  name: 'App',
  components:{
    Head,Nav,Foot
  }
}
</script>

<style scoped>
#app{
  background-color: #F5F5F5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue